import dayjs from 'dayjs';

import { DATE_TIME_SECONDS } from '../../../shared/contants/date';

export const getLocalDate = (time: Date): string => {
    const moscowTimeZone = 'Europe/Moscow';
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const moscowTime = dayjs.tz(time, moscowTimeZone);
    const userLocalTime = moscowTime.tz(userTimeZone);
    return userLocalTime.format(DATE_TIME_SECONDS);
};
